module.exports = __webpack_public_path__ + "static/media/1833.3b975383.jpg";